export default __webpack_public_path__ + "static/media/17.a5915bf3.png";